import { Cloud, CloudOff, RefreshCw, AlertTriangle } from 'lucide-react';
import { Link } from 'react-router';
import { useI18n } from '../i18n';
import { useSyncState } from './store';

/** Indicador compacto del estado de sincronización (FR-SYNC-10). */
export function SyncBadge() {
  const { t } = useI18n();
  const s = useSyncState();
  if (!s.signedIn) return null;
  const label =
    s.phase === 'syncing'
      ? t('sync.status.syncing')
      : s.phase === 'offline'
        ? t('sync.status.offline')
        : s.phase === 'error'
          ? t('sync.status.error')
          : s.pending > 0
            ? t('sync.status.pending', { count: s.pending })
            : t('sync.status.idle');
  const Icon = s.phase === 'syncing' ? RefreshCw : s.phase === 'offline' ? CloudOff : s.phase === 'error' ? AlertTriangle : Cloud;
  return (
    <Link to="/settings/account" className="icon-btn" aria-label={label} title={label} data-sync-phase={s.phase}>
      <Icon size={20} aria-hidden="true" />
    </Link>
  );
}
